"use strict";
/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importStar(require("react"));
const native_1 = require("styled-components/native");
const icons_1 = require("../icons");
const S = __importStar(require("./TextInput.styles"));
exports.TextInput = react_1.default.forwardRef((props, ref) => {
    const { disabled = false, error = false, success = false, accessibilityLabel, accessibilityHint, enableClearInput = false, onClear, onFocus, onBlur, maxLength, ...rest } = props;
    const [active, setActive] = react_1.useState(false);
    const theme = native_1.useTheme();
    const onInputFocus = () => {
        setActive(true);
        if (onFocus) {
            onFocus();
        }
    };
    const onInputBlur = () => {
        setActive(false);
        if (onBlur) {
            onBlur();
        }
    };
    const clearInputButtonColor = () => {
        if (error) {
            return theme.bpCore.colors.error;
        }
        if (success) {
            return theme.bpCore.colors.success;
        }
        return theme.bpCore.colors.light[900];
    };
    return (react_1.default.createElement(S.StyledTextWrapper, null,
        react_1.default.createElement(S.StyledTextInput, Object.assign({ maxLength: maxLength, enableClearInput: enableClearInput, error: !!error, success: success, active: active, disabled: disabled, accessible: true, accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, testID: accessibilityLabel, placeholderTextColor: theme.bpCore.textInput.default.placeholderColor, onFocus: onInputFocus, onBlur: onInputBlur, ref: ref }, rest)),
        enableClearInput && (react_1.default.createElement(S.CrossIconContainer, { onPress: onClear, testID: "Clear", accessibilityLabel: "Clear", accessibilityHint: "Clear text from field" },
            react_1.default.createElement(icons_1.Close, { color: clearInputButtonColor() }))),
        error && !enableClearInput && (react_1.default.createElement(S.IconContainer, { type: "error", testID: "ErrorIcon" },
            react_1.default.createElement(icons_1.InputError, null))),
        success && !enableClearInput && (react_1.default.createElement(S.IconContainer, { type: "success", testID: "SuccessIcon" },
            react_1.default.createElement(icons_1.Check, null)))));
});
